import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect$dRandom$dWeighted from "../Effect.Random.Weighted/index.js";
import * as Restaumatic$dCart$dDetail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dQuery from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic$dMenu$dV2$dAllergens from "../Restaumatic.Menu.V2.Allergens/index.js";
import * as Restaumatic$dMenu$dV2$dCartToOrder from "../Restaumatic.Menu.V2.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dProductKey from "../Restaumatic.Menu.V2.ProductKey/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const $Implementation = tag => ({tag});
const sum = /* #__PURE__ */ Data$dFoldable.foldlArray(Data$dSemiring.numAdd)(0.0);
const any = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupDisj1 = {append: v => v1 => v || v1};
  return {mempty: false, Semigroup0: () => semigroupDisj1};
})()))();
const elem = /* #__PURE__ */ (() => {
  const any1$1 = Data$dSet.foldableSet.foldMap((() => {
    const semigroupDisj1 = {append: v => v1 => v || v1};
    return {mempty: false, Semigroup0: () => semigroupDisj1};
  })());
  return x => any1$1(y => {
    if (x.tag === "Site") { return y.tag === "Site"; }
    if (x.tag === "ROS") { return y.tag === "ROS"; }
    if (x.tag === "Apetilo") { return y.tag === "Apetilo"; }
    if (x.tag === "Integrations") { return y.tag === "Integrations"; }
    if (x.tag === "QrWaiter") { return y.tag === "QrWaiter"; }
    return false;
  });
})();
const member = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1.tag === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1.tag === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1.tag === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const mempty1 = /* #__PURE__ */ (() => Data$dMap$dInternal.monoidMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId).mempty)();
const mempty2 = /* #__PURE__ */ (() => Data$dMap$dInternal.monoidMap(Data$dOrd.ordString).mempty)();
const any1 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupDisj1 = {append: v => v1 => v || v1};
  return {mempty: false, Semigroup0: () => semigroupDisj1};
})()))();
const elem1 = /* #__PURE__ */ (() => {
  const any1$1 = Data$dFoldable.foldableArray.foldMap((() => {
    const semigroupDisj1 = {append: v => v1 => v || v1};
    return {mempty: false, Semigroup0: () => semigroupDisj1};
  })());
  return x => any1$1($0 => x === $0);
})();
const Static = /* #__PURE__ */ $Implementation("Static");
const Disabled = /* #__PURE__ */ $Implementation("Disabled");
const Automatic = /* #__PURE__ */ $Implementation("Automatic");
const eqImplementation = {
  eq: x => y => {
    if (x.tag === "Static") { return y.tag === "Static"; }
    if (x.tag === "Disabled") { return y.tag === "Disabled"; }
    if (x.tag === "Automatic") { return y.tag === "Automatic"; }
    return false;
  }
};
const scheduleAvailable = v => v1 => {
  if (v1.tag === "Just") {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v1._1)(v.schedules);
    if ($0.tag === "Nothing") { return false; }
    if ($0.tag === "Just") { return $0._1; }
    return false;
  }
  if (v1.tag === "Nothing") { return true; }
  $runtime.fail();
};
const itemProductId = item => Data$dRecord.unsafeGet("productId")((() => {
  const $0 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, Data$dRecord.unsafeGet("parts")(Data$dRecord.unsafeGet("content")(item.item)), 0);
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
})());
const categoryKeywords = [
  "alkohol",
  "bajgle",
  "bezalkoholowe",
  "bułeczki",
  "bułeczka",
  "bułka",
  "bułki",
  "buły",
  "buła",
  "ciasta",
  "ciasto",
  "deser",
  "dodatki",
  "dodatkowe",
  "dodatek",
  "dressing",
  "drink",
  "finger",
  "frytki",
  "herbata",
  "herbaty",
  "kawa",
  "kawy",
  "koktajle",
  "lemoniady",
  "lemoniada",
  "nachos",
  "napoje",
  "napój",
  "oliwy",
  "oliwa",
  "owoców",
  "owocow",
  "pancake",
  "pieczywo",
  "piwa",
  "piwo",
  "przekąski",
  "przystawki",
  "sałatka",
  "sałatki",
  "sałaty",
  "smoothie",
  "soki",
  "sosy",
  "starter",
  "surówka",
  "surówki",
  "słodkie",
  "słodko",
  "słodkości",
  "tapas",
  "wina",
  "wino",
  "wypieki",
  "zakąski"
];
const assignUnknownWeights = unknownFraction => xs => {
  const totalKnown = sum(Data$dArray.mapMaybe(Data$dTuple.snd)(xs));
  const numUnknown = Data$dArray.filterImpl(
    x => {
      if (x._2.tag === "Nothing") { return true; }
      if (x._2.tag === "Just") { return false; }
      $runtime.fail();
    },
    xs
  ).length;
  const singleUnknown = numUnknown === 0 ? 0.0 : unknownFraction / Data$dInt.toNumber(numUnknown);
  const knownScaleFactor = totalKnown === 0.0 ? 0.0 : (1.0 - unknownFraction) / totalKnown;
  return Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
    v._1,
    (() => {
      if (v._2.tag === "Nothing") { return singleUnknown; }
      if (v._2.tag === "Just") { return v._2._1 * knownScaleFactor; }
      $runtime.fail();
    })()
  ))(xs);
};
const computeSuggestedItems = v => {
  const $0 = v.implementation;
  const $1 = v.locale;
  const $2 = v.maxItems;
  const $3 = v.menu;
  const $4 = v.menuEnv;
  const $5 = v.menuOrderOrigin;
  const $6 = v.productIds;
  const $7 = v.weights;
  const catalogue = v.catalogueMemo.catalogue;
  const $8 = (() => {
    if ($0.tag === "Static") {
      const $8 = Control$dBind.arrayBind(Data$dArray.mapMaybe(Restaumatic$dMenu$dV2$dMenuCatalogue.lookupCrossSellingList(catalogue))(Data$dArray.nubBy(Data$dOrd.ordString.compare)(Data$dArray.mapMaybe(productId => {
        const $8 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
        if ($8.tag === "Just") {
          const $9 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(Data$dRecord.unsafeGet("category")($8._1))(Data$dRecord.unsafeGet("categories")(catalogue));
          if ($9.tag === "Just") {
            const $10 = Data$dRecord.unsafeGet("crossSellingListOverride")($8._1);
            const $11 = Data$dRecord.unsafeGet("defaultCrossSellingList")($9._1);
            if ($10.tag === "Nothing") { return $11; }
            return $10;
          }
          if ($9.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        }
        if ($8.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })($6))))(list => Data$dFunctor.arrayMap(v1 => (
        {itemId: v1._1, item: {content: Restaumatic$dMenu$dV2$dProductKey.overwriteCartProductKey(catalogue)(Data$dRecord.unsafeGet("content")(v1._2))}}
      ))(Data$dRecord.unsafeGet("items")(list)._2));
      return () => $8;
    }
    if ($0.tag === "Disabled") { return () => []; }
    if ($0.tag === "Automatic") {
      const categories = Data$dMap$dInternal.filterWithKey(Data$dOrd.ordString)(v$1 => category => any(kw => Data$dString$dCodeUnits.contains(kw)(Data$dString$dCommon.toLower(Data$dRecord.unsafeGet("name")(category))))(categoryKeywords))(Data$dRecord.unsafeGet("categories")(catalogue));
      const $8 = Data$dArray.mapMaybe(item => {
        if (item.tag === "SingleProduct") {
          const $8 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(item._1.itemProduct)(Data$dRecord.unsafeGet("products")(catalogue));
          if ($8.tag === "Just") {
            if (elem(v.menuConsumer)(Data$dRecord.unsafeGet("visibleIn")($8._1))) {
              if (member(Data$dRecord.unsafeGet("category")($8._1))(categories)) {
                return Data$dMaybe.$Maybe(
                  "Just",
                  {itemId: item._1.itemProduct, item: {content: Restaumatic$dMenu$dV2$dProductKey.mkProductKey(v.catalogueMemo)(item._1.itemProduct)($8._1)(mempty1).productKey()}}
                );
              }
              return Data$dMaybe.Nothing;
            }
            return Data$dMaybe.Nothing;
          }
          if ($8.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        }
        return Data$dMaybe.Nothing;
      })(Control$dBind.arrayBind(Data$dArray.filterImpl(
        section => Data$dRecord.unsafeGet("visible")(section) && elem(v.menuConsumer)(Data$dRecord.unsafeGet("visibleIn")(section)) && scheduleAvailable($4)(Data$dRecord.unsafeGet("visibilitySchedule")(section)),
        Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr, Data$dRecord.unsafeGet("sections")(catalogue))
      ))(x => {
        const $8 = Data$dRecord.unsafeGet("content")(x);
        if ($8.tag === "Products") { return Data$dArray.fromFoldableImpl(Data$dMap$dOrdered.foldableOMap.foldr, $8._1.items); }
        return [];
      }));
      return () => $8;
    }
    $runtime.fail();
  })();
  return () => {
    const candidateItems = $8();
    const $9 = Data$dArray.mapMaybe(item => {
      const content = Data$dRecord.unsafeGet("content")(item.item);
      const $9 = Restaumatic$dMenu$dV2$dCartToOrder.cartProductToOrderItems(catalogue)($1)($4.schedules)(content)(Data$dMap$dInternal.$$$Map(
        "Node",
        1,
        1,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.Origin,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("OriginChoice", $5),
        Data$dMap$dInternal.Leaf,
        Data$dMap$dInternal.Leaf
      ))(mempty2);
      if ($9.tag === "Left") { return Data$dMaybe.Nothing; }
      if ($9.tag === "Right") {
        if ($9._1._2.length === 0) {
          const products = Data$dArray.mapMaybe(part => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(Data$dRecord.unsafeGet("productId")(part))(Data$dRecord.unsafeGet("products")(catalogue)))(Data$dArray.fromFoldableImpl(
            Data$dFoldable.foldrArray,
            Data$dRecord.unsafeGet("parts")(content)
          ));
          return Data$dMaybe.$Maybe(
            "Just",
            {
              details: {
                photo: Data$dFoldable.foldlArray(v$1 => v1 => {
                  if (v$1.tag === "Nothing") { return Data$dRecord.unsafeGet("photo")(v1); }
                  return v$1;
                })(Data$dMaybe.Nothing)(products),
                name: $9._1._1.name,
                description: Data$dString$dCommon.joinWith(". ")(Data$dArray.filterImpl(
                  v2 => v2 !== "",
                  [
                    (() => {
                      const $10 = Restaumatic$dMenu$dQuery.functorMenuQuery.map(Restaumatic$dCart$dDetail.productFullTextDescription($1))(Restaumatic$dCart$dDetail.productDetails($4)(Restaumatic$dCart$dProductKey.$ProductKey(
                        "MenuProduct",
                        content
                      )))($3);
                      if ($10.tag === "Left") { return ""; }
                      if ($10.tag === "Right") { return $10._1; }
                      $runtime.fail();
                    })(),
                    products.length === 1 ? Restaumatic$dI18n$dTypes.getLocalization($1)(Data$dRecord.unsafeGet("description")(products[0])) : ""
                  ]
                )),
                allergens: Restaumatic$dMenu$dV2$dAllergens.productKeyAllergens(catalogue)(content),
                unitPrice: $9._1._1.unitPrice
              },
              ...item
            }
          );
        }
        return Data$dMaybe.Nothing;
      }
      $runtime.fail();
    })(Data$dArray.filterImpl(
      v1 => !any1(part => elem1(Data$dRecord.unsafeGet("productId")(part))($6))(Data$dRecord.unsafeGet("parts")(Data$dRecord.unsafeGet("content")(v1.item))),
      candidateItems
    ));
    if ($0.tag === "Automatic") {
      const mainProductCategories = Data$dFunctor.arrayMap(v1 => Data$dRecord.unsafeGet("category")(v1))(Data$dArray.mapMaybe(Restaumatic$dMenu$dV2$dMenuCatalogue.lookupProduct(catalogue))($6));
      const result = Effect$dRandom$dWeighted.weightedRandomN($2)(Data$dTuple.snd)(assignUnknownWeights(0.2)(Data$dFunctor.arrayMap(x => Data$dTuple.$Tuple(
        x,
        (() => {
          const $10 = sum(Data$dArray.mapMaybe(c => {
            const $10 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(c)($7);
            const $11 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemProductId(x));
            if ($10.tag === "Just") { return $11($10._1); }
            if ($10.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })(mainProductCategories));
          if ($10 === 0.0) { return Data$dMaybe.Nothing; }
          return Data$dMaybe.$Maybe("Just", $10);
        })()
      ))($9)))();
      return Data$dFunctor.arrayMap(Data$dTuple.fst)(result);
    }
    if ($0.tag === "Disabled") { return []; }
    if ($0.tag === "Static") { return $2 < 1 ? [] : Data$dArray.sliceImpl(0, $2, $9); }
    $runtime.fail();
  };
};
export {
  $Implementation,
  Automatic,
  Disabled,
  Static,
  any,
  any1,
  assignUnknownWeights,
  categoryKeywords,
  computeSuggestedItems,
  elem,
  elem1,
  eqImplementation,
  itemProductId,
  member,
  mempty1,
  mempty2,
  scheduleAvailable,
  sum
};
